import { useContext } from "react";
import { Box } from "@mui/material";
import TPLMenuBar from "./TPLMenuBar";
import CityContext from "../../contexts/CityContext";
import ProgressBar from "./ProgressBar";
import { AlignmentContext } from "../../contexts/AlignmentContext";
import TenMinuteButton from "../panels/TenMinuteButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { dataFields } from "../../constants";

const SubNavbar = () => {
  // The matches variable keeps track of whether the screen is less than 1000px wide so the app will render correctly for mobile
  const matches = useMediaQuery("(max-width:1000px)");
  const { city, urban } = useContext(CityContext);

  const { alignment, setAlignment } = useContext(AlignmentContext);

  return (
    <Box
      className="subnavbar__container"
      zIndex={100}
      sx={{ backgroundColor: "earth.main" }}
    >
      {/* The TPLMenuBar component (tabs for the left panel) will display if the screen is greater than 1000px */}
      {!matches && (
        <Box display="flex" flex={1} alignItems="center" width="100%">
          <TPLMenuBar />
        </Box>
      )}
      {/* If there is a value for city or urban area, the progress bar will display */}
      {(city || urban) && (
        <Box display="flex" flex={1} justifyContent="center">
          {city && alignment !== "urban" ? (
            <ProgressBar
              header="Percent of city population within 10-minute walk park access"
              value={Math.round(
                  (city?.attributes[dataFields["SUM_TOTPOPSVCA"]] /
                  city?.attributes[dataFields["SUM_TPL_TOT_POP"]]) *
                  100
              )}
            />
          ) : (
            ""
          )}
          {urban && alignment === "urban" ? (
            <ProgressBar
              header="Percent of urban population within 10-minute walk park access"
              value={Math.round(
                  (urban?.attributes[dataFields["SUM_TOTPOPSVCA"]] /
                      urban?.attributes[dataFields["SUM_TPL_TOT_POP"]]) *
                  100
              )}
            />
          ) : (
            ""
          )}
        </Box>
      )}
      {/* The TenMinuteButton component (controller for the right panel) will display if the screen is greater than 1000px */}
      {!matches && <TenMinuteButton />}
    </Box>
  );
};

export default SubNavbar;
